import React from 'react';
import type { TemplatePhase } from './templateManagementService';

interface TemplateDetailTimelineProps {
  phases: TemplatePhase[];
}

const TemplateDetailTimeline: React.FC<TemplateDetailTimelineProps> = ({ phases }) => {
  if (phases.length === 0) {
    return <p className="text-sm text-gray-500 dark:text-gray-400">No phase/task data is available for this template.</p>;
  }

  return (
    <div className="space-y-4">
      {phases.map((phase) => (
        <section key={`${phase.id || phase.name}-${phase.order}`} className="rounded-lg border border-gray-200 p-4 dark:border-gray-700">
          <h4 className="text-sm font-semibold text-gray-900 dark:text-gray-100">
            Phase {phase.order}: {phase.name}
          </h4>
          {phase.description && <p className="mt-1 text-sm text-gray-600 dark:text-gray-300">{phase.description}</p>}

          <ul className="mt-3 space-y-3">
            {phase.tasks.map((task, index) => (
              <li key={`${task.title}-${index}`} className="rounded-md bg-gray-50 p-3 dark:bg-gray-800/70">
                <div className="flex flex-wrap items-center gap-2">
                  <span className="text-sm font-medium text-gray-900 dark:text-gray-100">{task.title}</span>
                  {task.is_court_mandated && (
                    <span className="rounded-full bg-rose-100 px-2 py-0.5 text-xs font-semibold text-rose-700 dark:bg-rose-900/30 dark:text-rose-200">
                      Court Mandated
                    </span>
                  )}
                </div>
                <div className="mt-1 text-xs text-gray-600 dark:text-gray-300">
                  Due: Day {typeof task.due_date_offset_days === 'number' ? task.due_date_offset_days : 'N/A'} • Priority:{' '}
                  {task.priority || 'medium'} • Assignee: {task.assignee_role || 'Unassigned'}
                </div>
                {task.description && <p className="mt-2 text-sm text-gray-700 dark:text-gray-300">{task.description}</p>}
                {task.mandate_reference && (
                  <p className="mt-2 text-xs text-rose-700 dark:text-rose-300">Mandate: {task.mandate_reference}</p>
                )}
              </li>
            ))}
          </ul>
        </section>
      ))}
    </div>
  );
};

export default TemplateDetailTimeline;

